import { createApp } from 'vue'
import { createPinia } from 'pinia'

import * as Sentry from '@sentry/vue'
import { createSentryPiniaPlugin } from '@sentry/vue'

import App from './App.vue'
import router from './router'
import { captureStaticSignupForm } from './signupStaticForm'

import './navbar'
import './messages'
import './assets/main.scss'
import '@/styles/bootstrap-overrides.scss'

const app = createApp(App)

Sentry.init({
  app,
  dsn: 'https://128e2d0483ba419680f4a120d47e4284@sentry.io/262798',
})

const pinia = createPinia()
pinia.use(createSentryPiniaPlugin())

app.use(pinia)
app.use(router)

// Keeps BootstrapVue3 and FontAwesome out of the signup-critical entry chunk.
let dashboardUi: Promise<void> | undefined
router.beforeResolve(async to => {
  if (to.path.startsWith('/dashboard')) {
    dashboardUi ??= import('./dashboardUi').then(ui =>
      ui.installDashboardUi(app),
    )
    try {
      await dashboardUi
    } catch (e) {
      // Clearing lets the next navigation retry a failed chunk load.
      dashboardUi = undefined
      throw e
    }
  }
})

captureStaticSignupForm()
app.mount('#app')
